import React from 'react';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.errorCode}>404</div>
        <h1 style={styles.title}>Страница не найдена</h1>
        <p style={styles.description}>
          Запрашиваемая страница не существует или была удалена.
          Возможно, вы перешли по устаревшей ссылке.
        </p>
        <div style={styles.actions}>
          <button 
            onClick={() => navigate('/')} 
            style={styles.primaryBtn}
          >
            ← Вернуться на главную
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'var(--bg-dark)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    fontFamily: 'Cormorant Garamond, serif'
  },
  content: {
    textAlign: 'center',
    maxWidth: '600px'
  },
  errorCode: {
    fontSize: 'clamp(6rem, 15vw, 10rem)',
    fontWeight: 300,
    color: 'var(--accent)',
    lineHeight: 1,
    marginBottom: '20px',
    fontFamily: 'Special Elite, monospace',
    letterSpacing: '10px',
    textShadow: '0 0 40px rgba(201, 169, 110, 0.3)'
  },
  title: {
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: 300,
    color: 'var(--text-light)',
    marginBottom: '20px',
    fontFamily: 'Cormorant Garamond, serif'
  },
  description: {
    fontSize: '1.1rem',
    color: 'var(--text-muted)',
    lineHeight: 1.7,
    marginBottom: '40px',
    maxWidth: '500px',
    margin: '0 auto 40px'
  },
  actions: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  primaryBtn: {
    background: 'var(--accent)',
    border: '1px solid var(--accent)',
    color: 'var(--bg-dark)',
    padding: '14px 32px',
    cursor: 'pointer',
    fontFamily: 'Special Elite, monospace',
    fontSize: '0.9rem',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    transition: 'all 0.3s',
    borderRadius: '4px'
  },
  secondaryBtn: {
    background: 'transparent',
    border: '1px solid var(--accent-dim)',
    color: 'var(--text-light)',
    padding: '14px 32px',
    cursor: 'pointer',
    fontFamily: 'Special Elite, monospace',
    fontSize: '0.9rem',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    transition: 'all 0.3s',
    borderRadius: '4px'
  }
};